class EcuController {
    constructor() {
        // Selectors
        this.selectors = {
            ecuButton: '.js__active_ecus',
            ecuTab: '.ecu_tab',
            servicesList: '.js__services_list_wrapper',
            openListButton: '.js__open_list_ecu',
            customDropList: '.custom_drop_list',
            stageButton: '.js__stage_btn',
            stageTab: '.stage_tab',
            chartBlock: '.chip_tuning_chart_block',
            startNode: '.start',
            endNode: '.end',
            growthNode: '.growth',
            svgStart: '.svg_start',
            svgEnd: '.svg_end',
            ecuList: '.js__ecus_list'
        };

        // Animation constants
        this.animationConfig = {
            duration: 1200,
            maxWidth: '93%'
        };
    }

    init() {
        this.initEventListeners();
        this.startAnimation();
    }

    initEventListeners() {
        $(document)
            .on('click', this.selectors.ecuButton, (e) => this.handleEcuClick(e))
            .on('click', this.selectors.openListButton, (e) => this.handleOpenListClick(e))
            .on('click', this.selectors.stageButton, (e) => this.handleStageClick(e));
    }

    handleEcuClick(event) {
        this.removeOpen();
        const $button = $(event.currentTarget);
        const id = $button.attr('data-value');
        const $wrapper = $(`${this.selectors.ecuTab}[data-id=${id}]`);

        $(this.selectors.ecuTab).removeClass('active');
        $wrapper.addClass('active');
        $(`${this.selectors.servicesList}[data-id=${id}]`).addClass('active');
        $wrapper.find(this.selectors.stageButton).trigger('click');
    }

    handleOpenListClick(event) {
        const $button = $(event.currentTarget);
        const $wrapper = $button.closest('.select_drop');
        $button.toggleClass('active');
        $wrapper.find(this.selectors.customDropList).slideToggle();
    }

    handleStageClick(event) {
        const $button = $(event.currentTarget);
        $(this.selectors.stageButton).removeClass('active');
        $button.addClass('active');

        const id = $button.attr('data-id');
        $(this.selectors.stageTab).removeClass('active');
        $(`${this.selectors.stageTab}[data-id=${id}]`).addClass('active');

        this.startAnimation();
    }

    startAnimation() {
        $(`${this.selectors.ecuTab}.active ${this.selectors.stageTab}.active ${this.selectors.chartBlock}`)
            .each((_, element) => {
                const $chart = $(element);
                const typeChart = $chart.attr('data-type');
                const $startNode = $chart.find(this.selectors.startNode);
                const $endNode = $chart.find(this.selectors.endNode);
                const $growthNode = $chart.find(this.selectors.growthNode);

                const start = parseFloat($startNode.attr('data-start').trim());
                const end = parseFloat($endNode.attr('data-end').trim());

                const { widthStart, widthEnd } = this.calculateWidths(typeChart, start, end);

                this.animateChart($startNode, $endNode, $growthNode, widthStart, widthEnd);
            });
    }

    calculateWidths(typeChart, start, end) {
        let widthStart, widthEnd;

        if (typeChart === 'engine_power') {
            widthStart = start > 190 ? 27 : 24;
            widthEnd = end > 230 ? widthStart + 27 : widthStart + 24;
        } else {
            widthStart = start > 300 ? 36 : 33;
            widthEnd = end > 400 ? widthStart + 27 : widthStart + 24;
        }

        return { widthStart, widthEnd };
    }

    animateChart($startNode, $endNode, $growthNode, widthStart, widthEnd) {
        // Reset styles
        $startNode.closest('.chip_tuning_chart_item').find(this.selectors.svgStart).css('left', '');
        $startNode.css('width', '');
        $endNode.closest('.chip_tuning_chart_item').find(this.selectors.svgEnd).css('left', '');
        $endNode.css({ 'padding-right': '', 'width': '' });
        $growthNode.css('width', '');

        // Animate start node
        $startNode.closest('.chip_tuning_chart_item').find(this.selectors.svgStart)
            .animate({ left: `${widthStart}%` }, this.animationConfig.duration);

        $startNode.animate({ width: `${widthStart}%` }, this.animationConfig.duration, () => {
            // Set initial end node styles
            $endNode.css({
                'padding-right': '50px',
                'width': `${widthStart}%`
            });

            $endNode.closest('.chip_tuning_chart_item').find(this.selectors.svgEnd)
                .css('left', `${widthStart}%`)
                .animate({ left: `${widthEnd}%` }, this.animationConfig.duration);

            $endNode.animate({ width: `${widthEnd}%` }, this.animationConfig.duration, () => {
                $growthNode.css('width', `${widthEnd}%`)
                    .animate({ width: this.animationConfig.maxWidth }, this.animationConfig.duration);
            });
        });
    }

    removeOpen() {
        $(`${this.selectors.ecuList} ${this.selectors.customDropList}`).slideUp();
        $(this.selectors.openListButton).removeClass('active');
        $(this.selectors.servicesList).removeClass('active');
    }
}

// Create a global instance
window.ecuController = new EcuController();